export function formatEuroCents(cents: number): string {
  return (
    (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
    ' €'
  );
}

/**
 * F1/F2 (FR-75/FR-77): display name for an admin/chair account, falling
 * back to the email when `given_name`/`family_name` are absent (pre-v0.3
 * accounts, not yet backfilled).
 */
export function displayName(user: {
  firstName?: string;
  lastName?: string;
  email: string;
}): string {
  const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  return name || user.email;
}

/**
 * A bare clock time is ambiguous the moment the list covers more than one
 * day — and it covers a whole month (the list runs until the Monatsevent
 * rolls over on the 1st). Half a dozen rows legitimately read "18:42", with
 * nothing to say which was tonight (owner, 2026-08-27).
 *
 * EVERY row is dated, today's included. The first attempt left today as a
 * bare time — reasoning that the date would be noise on the common case —
 * and the owner, testing with bookings made minutes earlier, reported seeing
 * no timestamp at all. A row that reads "18:30" does not announce itself as
 * a timestamp; one that reads "Heute · 18:30" does. Cleverness that makes
 * the information look absent is worse than the repetition it saves.
 *
 * Older rows carry the weekday first: training runs on fixed days, so "Di."
 * places a booking faster than "12.08." does.
 */
export function formatBookingTime(iso: string, now: Date = new Date()): string {
  const at = new Date(iso);
  const time = at.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
  if (at.toDateString() === now.toDateString()) return `Heute · ${time}`;
  const day = at.toLocaleDateString('de-DE', {
    weekday: 'short',
    day: '2-digit',
    month: '2-digit',
  });
  return `${day} · ${time}`;
}
